import React, { Component } from "react";
import PropTypes from "prop-types";
import "./JobListDropDown.css";
import onClickOutside from "react-onclickoutside";

/**
 * @desc JobListDropDown
 * @param props
 * @return null
 */
const JobListDropDown = props => {
  return (
    <React.Fragment>
      <div
        className={
          props.showDropDown ? "joblist-selector" : "joblist-selector hide"
        }
        handleClickOutside={props.handleClickOutside}
      >
        {props.items}
      </div>
    </React.Fragment>
  );
};

export default onClickOutside(JobListDropDown);



// WEBPACK FOOTER //
// ./src/components/UI/JobListDropDown/JobListDropDown.js